<div
  class="orgbrain-border br-1 small-shadow card cursor-pointer"
  (click)="cardClick.emit()"
  style="max-width: 540px"
  *ngIf="type === 'small'"
>
  <div class="!mx-4 !my-2 d-flex justify-between align-items-center">
    <div>
      <h4 class="orgbrain-larger-text !my-1">{{ header }}</h4>
      <p class="orgbrain-gray-text !my-0">{{ subheader }}</p>
    </div>
  </div>
</div>

<div
  class="orgbrain-border br-1 small-shadow hidden-element-until-hover card h-100 d-flex flex-direction-column justify-content-space-between"
  style="max-width: 540px"
  *ngIf="type === 'medium'"
>
  <div class="!mx-4 !mt-4">
    <div class="d-flex gap-x-2 justify-between align-center !mb-1">
      <h4 class="orgbrain-18px-text !my-0">{{ header }}</h4>
      @if (labelAsTag) {
        <div class="p-2 rounded-md border !max-h-5 text-white" [ngClass]="labelBg">{{ label }}</div>
      } @else {
        <p class="orgbrain-gray-text !my-0">{{ label }}</p>
      }
    </div>

    <p class="orgbrain-text !my-0">{{ subheader }}</p>
  </div>
  <ng-content></ng-content>
  <div class="d-flex justify-between gap-x-2 !mx-4 !mt-2 !pb-2">
    <div
      class="d-flex gax-x-1"
      [ngClass]="!showButtons ? 'hidden-element' : ''"
      *ngIf="extraButtons?.length > 0"
    >
      <ng-container *ngFor="let iconbutton of extraButtons; let last = last">
        <button
          *ngIf="iconbutton"
          class="icon-button select"
          (click)="toolbarClick.emit(iconbutton.id)"
          [matTooltip]="iconbutton.tooltip"
        >
          <mat-icon> {{ iconbutton.icon }}</mat-icon>
        </button>
      </ng-container>
    </div>

    <button mat-button (click)="cardClick.emit()" color="primary">{{ button }}</button>
  </div>
</div>
